import React from "react";
import Category from "./Category";
export default function DropDown(props) {
  const toSentenceCase = camel => {
    const result = camel.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  };
  return (
    <div className="buttonContainer">
      {Object.entries(props.codes.category).map((item, i) => {
        return (
          <Category
            key={item + i}
            codes={props.codes}
            section={item[0]}
            category={toSentenceCase(item[0])}
            border={props.border}
          />
        );
      })}
    </div>
  );
}
